// extracted by mini-css-extract-plugin
export var comfortable = "contact-block-module--comfortable--e1384";
export var compact = "contact-block-module--compact--a80e4";
export var contactBlockItem = "contact-block-module--contact-block-item--ad350";
export var contacts = "contact-block-module--contacts--39975";
export var wrapper = "contact-block-module--wrapper--ea435 secondary-footer-module--blue--1bdf4 secondary-footer-module--wrapper--ce03e container-module--wrapper--c1517 container-module--wrapper--c1517";